module.exports = __webpack_public_path__ + "static/media/Logo_SC_Bern.480cd114.svg";